import * as React from 'react';
import { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import { BlogSlider } from '../Blog/BlogSlider';

export class StaticInfoComponent extends Component {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className="static-info-component">
                <div className="how-it-works">
                    <h2 className="section-maintitle">Jak to działa?</h2>
                    <ScrollAnimation animateIn="fadeIn" duration={0.65} delay={150} animateOnce={true}>
                        <div className="three-sections">
                            <div className="find section">
                                <h3>Znajdź</h3>
                                <p>Szukaj wśród zaufanych fizjoterapeutów w okolicy.</p>
                            </div>
                            <div className="select section">
                                <h3>Wybierz</h3>
                                <p>Sprawdź dostępność, specjalizację i wybierz fizjoterapeutę.</p>
                            </div>
                            <div className="arrange section">
                                <h3>Umów wizytę</h3>
                                <p>Wybierz termin i potwierdź dane kontaktowe, aby otrzymać przypomnienie o wizycie.</p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
                <div className="description">
                    <ScrollAnimation animateIn="fadeIn" duration={0.75} animateOnce={true}>
                        <h2 className="section-maintitle">Sprawdzeni fizjoterapeuci dla Ciebie i Twoich bliskich</h2>
                        <p>W serwisie znajdziesz wyłącznie sprawdzonych fizjoterapeutów, którzy posiadają aktualne prawo wykonywania zawodu.
                            <br />
                            Sprawdź specjalizację, dostępność oraz profil.</p>
                        <p>Wybierz specjalistę, który odpowiada Twoim potrzebom. Szukaj w&nbsp;najbliższej okolicy, pod kątem terapii czy schorzenia.
                            <br />
                            <b>Bezpłatnie, szybko i pewnie!</b></p>
                        <p>Serwis wspiera <a href="https://kif.info.pl" target="_blank" className="description-link">
                            <b>Krajowa Izba Fizjoterapeutów</b>
                        </a>.
                        </p>
                    </ScrollAnimation>
                </div>
                <div className="search-info">
                    <h2 className="section-maintitle">Umów wizytę - szybko i wygodnie</h2>
                    <div className="search-view-wrapper">
                        <div className="search-view">
                            <div className="search-view-container">
                                <div className="search-view-card-1" />
                                <div className="search-view-card-2" />
                                <div className="search-view-card-3" />
                                <div className="search-view-card-4" />
                            </div>
                        </div>
                    </div>
                    <div className="search-conditions">
                        <ScrollAnimation animateIn="fadeInDown" duration={0.35} animateOnce={true}>
                            <div className="search-conditions-item pricing">
                                <h3>Bezpłatnie</h3>
                                <p>
                                    Nasz serwis jest i będzie bezpłatny. Tak jak lubisz!
                                </p>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeInDown" duration={0.35} delay={300} animateOnce={true}>
                            <div className="search-conditions-item territory">
                                <h3>Cała Polska</h3>
                                <p>
                                    Tu znajdziesz godnych zaufania fizjoterapeutów z całego kraju.
                                </p>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeInDown" duration={0.35} delay={600} animateOnce={true}>
                            <div className="search-conditions-item time">
                                <h3>Umawianie wizyt 24/7</h3>
                                <p>
                                    Umawiaj wizyty o dowolnej porze.
                                </p>
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
                <div className="blog-section">
                    <ScrollAnimation animateIn="fadeIn" duration={0.5} animateOnce={true}>
                        <Link to="/blog">
                            <h2 className="section-maintitle">Blog o fizjoterapii</h2>
                        </Link>
                        <div className="section-description-container">
                            <p className="section-description">Ekspercki blog poświęcony poradom i informacjom o fizjoterapii. Jeśli jesteś fizjoterapeutą lub pacjentem na pewno znajdziesz coś dla siebie.</p>
                            <Link to="/blog">
                                <span className="section-see-more">Więcej artykułów</span>
                            </Link>
                        </div>
                        <BlogSlider />
                    </ScrollAnimation>
                </div>
            </div>
        );
    }//end-of-render
}


// WEBPACK FOOTER //
// ./src/components/Home/StaticInfo.tsx